/*
 * The WhatsApp linking section: the issue card with the command it answers, and the card of linked
 * numbers (the mockup's "connected" line per number). One column; every row wraps so a phone never
 * scrolls sideways (F-UIX-016).
 */
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  /* Full width, as the mockup's cards (UX-13 parity). */
}

.subtitle {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.body {
  margin: 0;
  color: var(--text-muted);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-2);
}

.label {
  font-weight: var(--font-weight-medium);
}

.command {
  flex: 1 1 12rem;
  min-width: 0;
  block-size: 32px;
  padding: 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font-family: ui-monospace, monospace;
  font-size: var(--font-size-13);
}

.command:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
}

.notice {
  min-height: 1.5rem;
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
}

.glyph {
  display: grid;
  place-items: center;
  flex: none;
  inline-size: 40px;
  block-size: 40px;
  border-radius: 50%;
  background: var(--surface-sunken);
  color: var(--text-muted);
}

.number {
  font-family: ui-monospace, monospace;
  font-weight: var(--font-weight-semibold);
  color: var(--text);
}

.who {
  display: flex;
  flex: 1 1 12rem;
  flex-direction: column;
  gap: 2px;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.meta {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
